import { render, staticRenderFns } from "./productDetails.html?vue&type=template&id=1d7ea88e&"
import script from "./productDetails.vue?vue&type=script&lang=js&"
export * from "./productDetails.vue?vue&type=script&lang=js&"
import style0 from "./productDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports